import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import {
  DISPLAY_PAYMENT_HISTORY,
  LOAD_PAYMENT_HISTORY,
} from "../../reducers/actions/Constants";

export default function* watcherLoadPaymentHistorySaga() {
  yield takeEvery(LOAD_PAYMENT_HISTORY, workerSaga);
}

function* workerSaga(action) {
  try {
    var payload = {};
    let reference = action.payload;
    const historyUrl = `/api/SalesTransactionV2/get-orders?transactionReference=${reference}`;
    yield request("get", payload, historyUrl).then((response) => {
      payload = response;
      console.log("here is the Sub Orders 👌", payload);
    });
    yield put({ type: DISPLAY_PAYMENT_HISTORY, payload });
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
